export enum PrescriptionStatus {
  ACTIVE = 'ACTIVE',
  ON_HOLD = 'ONHOLD',
  CANCELLED = 'CANCELLED',
  STOPPED = 'STOPPED',
  ENTERED_IN_ERROR = 'ENTEREDINERROR'
}

export const PrescriptionStatusMap: { [key in PrescriptionStatus]: string } = {
  [PrescriptionStatus.ACTIVE]: 'PrescriptionStatusActive',
  [PrescriptionStatus.ON_HOLD]: 'PrescriptionStatusOnHold',
  [PrescriptionStatus.CANCELLED]: 'PrescriptionStatusCancelled',
  [PrescriptionStatus.STOPPED]: 'PrescriptionStatusStopped',
  [PrescriptionStatus.ENTERED_IN_ERROR]: 'PrescriptionStatusEnteredInError'
};
